import camelCase from 'lodash/camelCase';
import React from 'react';
import { FeatureItemRow } from '../../atoms/FeatureItemRow';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';

export const FeatureGroup = ({ featureGroup, trimLevel, jargon }) => {

  if (!featureGroup.details_show) {

    return null;
  }
  if (!featureGroup.values.filter(f => f.details_show).map(v => camelCase(v.slug)).filter(slug => trimLevel[slug] !== null && typeof trimLevel[slug] !== 'undefined').length) {

    return null;
  }

  return (
    <Stack sx={{ mb: 4 }} spacing={3}>
      <Typography variant={'h4'}>{featureGroup.name}</Typography>
      <Grid container>
        {featureGroup.values.map((v, k) => (<FeatureItemRow jargon={jargon} item={v} key={k} trimLevel={trimLevel} />))}
      </Grid>
    </Stack>
  );
};

FeatureGroup.propTypes = {
  trimLevel: PropTypes.shape({}),
  featureGroup: PropTypes.shape({
    values: PropTypes.arrayOf(PropTypes.shape({})),
    details_show: PropTypes.bool,
    name: PropTypes.node.isRequired
  }),
  jargon: PropTypes.shape({})
};